export function blocksMapToSortedArray(blocksMap) {
    return blocksMap
        .toList()
        .sortBy((b) => b.get('order'))
        .map((b) => b.get('name'))
        .toArray()
}
